var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"to":_vm.link},on:{"click":function($event){return _vm.$emit('hidedrawer')}}},[_c('v-list-item-action',[_c('v-icon',[_vm._v("mdi-"+_vm._s(_vm.icon))])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.text))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }